<template>
  <div class="CreateUserSignup">
    <slot name="top"></slot>
    <div class="mainInputs">
      <TextInput
        v-validate:email
        :value="email"
        :disabled="disableEmailInput"
        :placeholder="
          $t('band.signup.init.createUserTemplate.placeholder.email')
        "
        picto="far fa-envelope"
        @input="$emit('update-email', $event)"
      >
        <template #errormsg>
          <div v-if="!email.length" class="errmsg">
            {{ $t("errors.input.required_field") }}
          </div>
          <div v-else class="errmsg">
            {{ $t("errors.input.unvalid_email") }}
          </div>
        </template>
      </TextInput>
      <TextInput
        v-validate:firstName
        :value="firstName"
        picto="far fa-user"
        :placeholder="
          $t('band.signup.init.createUserTemplate.placeholder.firstName')
        "
        @input="$emit('update-first-name', $event)"
      >
        <template #errormsg>
          <div class="errmsg">{{ $t("errors.input.required_field") }}</div>
        </template>
      </TextInput>
    </div>
    <div class="midWrapper">
      <slot name="mid"></slot>
    </div>
    <div class="cguWrapper">
      <Checkbox v-model="cgu" v-validate:cgu />
      <div class="cguText" :class="{ error: !validity.cgu }">
        <span>{{
          $t("band.signup.init.createUserTemplate.input.cguPlain")
        }}</span>
        <a
          class="underlined"
          :href="`/${$store.state.locale}/cgs/`"
          target="_blank"
          >{{
            $t("band.signup.init.createUserTemplate.input.cguUnderlined")
          }}</a
        >
      </div>
    </div>
    <MainBtn :disabled="loading" @click="handleMainBtnClick">
      <div class="btnText">
        {{ $t("band.signup.init.createUserTemplate.button.validationButton") }}
      </div>
    </MainBtn>
  </div>
</template>
<script>
import ValidityMixin from "~/mixins/validity"

import Checkbox from "~/components/inputs/checkbox"
import MainBtn from "~/components/shared/mainBtn"
import TextInput from "~/components/inputs/text"

export default {
  components: {
    Checkbox,
    MainBtn,
    TextInput,
  },
  mixins: [ValidityMixin],
  props: {
    email: {
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default() {
        return false
      },
      required: false,
    },
    disableEmailInput: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
  data() {
    return {
      cgu: false,
      validity: {
        email: true,
        firstName: true,
        cgu: true,
      },
    }
  },
  methods: {
    validate_cgu() {
      return this.cgu
    },
    validate_email() {
      return this.checkEmail(this.email.trim())
    },
    validate_firstName() {
      return this.firstName?.trim().length > 0 ?? false
    },
    handleMainBtnClick() {
      if (this.validate()) this.$emit("request-signup")
    },
  },
}
</script>
<style scoped>
.mainInputs {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
  margin-bottom: 16px;
}

.cguWrapper {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  margin-bottom: 32px;
}

.cguText {
  margin-top: 1px;
  margin-left: 8px;
}

.underlined {
  text-decoration: underline;
}

.midWrapper {
  margin-bottom: 16px;
}
</style>
